<template>
  <div class="filter-wrapper" :class="{ active: showSearch  }">
    <div
      v-click-outside="minify"
      @click="expand"
      class="filter"
    >
      <div class="filter-title">
        <span v-if="showSearch || !title2" class="filter-title-default">{{ title }}</span>
        <div v-else-if="title2" class="filter-title-custom">
          <span>{{ title }}:</span> <span class="value">{{ title2 }}</span>
        </div>
        <v-btn
          v-if="showSearch"
          @click.stop="minify"
          class="close-btn"
          fab
          color="red"
        >
          <v-icon color="#fff" @click.stop="clear">close</v-icon>
        </v-btn>
        <div v-else-if="title2" class="clear-btn">
          <v-icon
            @click.stop="clear"
            color="#fff"
          >
            close
          </v-icon>
        </div>
        <img
          v-else
          src="https://s3.amazonaws.com/images.growmindgrow/school-site/dropdown-arrow.svg"
          alt=""
        >
      </div>
      <perfect-scrollbar>
        <div class="filter-body">
          <div class="filter-body-search">
            <img
              src="https://s3.amazonaws.com/images.growmindgrow/school-site/zoom.svg"
              alt=""
            >
            <input
              v-model="search"
              ref="search"
              type="text"
              placeholder="Search"
              @keyup.enter="minify"
            >
          </div>
          <div
            v-for="(opt, i) in uniqueOptions"
            :key="i"
            class="filter-body-value"
            @click.stop="selectOpt(opt)"
          >
            {{ opt.name }}
          </div>
        </div>
      </perfect-scrollbar>
    </div>
  </div>
</template>

<script>
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';
import vClickOutside from 'v-click-outside';

export default {
  name: 'SchFilterOption',
  components: { PerfectScrollbar },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    inputVal: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
    },
  },
  data() {
    return {
      search: this.inputVal,
      prevSeachVal: '',
      showSearch: false,
      title2: '',
      value: '',
    };
  },
  computed: {
    lowercaseOpts() {
      return this.options.filter(opt => opt.name.toLowerCase().includes(this.search.toLowerCase()));
    },
    uniqueOptions() {
      let newArr = [];
      newArr = Array.from(new Set(this.lowercaseOpts.map(a => a.name)))
        // eslint-disable-next-line arrow-body-style
        .map((name) => {
          return this.lowercaseOpts.find(a => a.name === name);
        });
      return newArr;
    },
  },
  methods: {
    expand() {
      this.showSearch = true;
      this.$refs.search.focus();
    },
    minify() {
      if (this.showSearch) {
        this.title2 = this.search;
        this.showSearch = false;
        this.select();
      }
    },
    clear() {
      this.search = '';
      this.title2 = '';
      this.showSearch = false;
      this.$emit('update:inputVal', '');
      this.$emit('select');
    },
    selectOpt(opt) {
      this.title2 = opt.name;
      this.search = opt.name;
      this.showSearch = false;
      this.$emit('update:inputVal', opt.value);
      this.$emit('select');
    },
    select() {
      if (this.search !== this.prevSeachVal) {
        this.prevSeachVal = this.search;
        this.$emit('update:inputVal', this.search);
        this.$emit('select');
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '~vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';

.filter-wrapper {
  min-width: 260px;
  height: 37px;
  position: relative;

  &.active {
    z-index: 999;

    .filter {
      height: auto;
      transform: scale(1.15);
    }
  }

  .filter {
    background: #FFFFFF;
    border: 1px solid #CFC6C6;
    box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    overflow: hidden;
    width: 100%;
    height: 100%;
    transition: 0.35s;

    &-title {
      width: 100%;
      height: 37px;
      display: flex;
      align-items: center;
      text-transform: uppercase;
      font-size: 20px;
      letter-spacing: 1px;
      color: #A8A8A8;
      cursor: pointer;
      position: relative;

      &-default {
        width: 100%;
        text-align: center;
      }

      &-custom {
        padding: 0 16px 0 16px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        display: flex;
        align-items: center;

        .value {
          font-size: 16px;
          text-transform: none;
          color: #000;
          margin-left: 6px;
          padding-right: 16px;
        }
      }

      img {
        position: absolute;
        right: 10px;
        height: 12px;
      }

      .clear-btn {
        position: absolute;
        right: 0;
        background-color: #DBDBDB;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 28px;
      }

      .close-btn {
        position: absolute;
        right: 0;
        width: 27px;
        height: 27px;
      }
    }

    .ps {
      max-height: 240px;
    }

    &-body {
      background-color: #E8EFF5;
      padding: 10px 5px 6px;

      &-search {
        background-color: #E9E9E9;
        border: 1px solid #B7C5E8;
        border-radius: 5px;
        position: relative;
        width: 90%;
        margin: 0 auto;

        img {
          position: absolute;
          left: 6px;
          top: 50%;
          transform: translateY(-50%);
        }

        input {
          width: 100%;
          height: 30px;
          outline: none;
          padding: 0 30px;
        }
      }

      &-value {
        width: 90%;
        height: 30px;
        background: #F9F9FA;
        border: 1px solid #DDDDDD;
        border-radius: 5px;
        line-height: 30px;
        font-size: 14px;
        padding: 0 16px;
        margin: 2px auto;
        cursor: pointer;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }
}
</style>
